import React from 'react';
import { WidgetProps } from '@rjsf/core';
import { TextInput } from '../BaseComponents';

const CustomTextInput = (props: WidgetProps) => {
    const { schema, value, placeholder, onChange, uiSchema } = props;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e?.target?.value);
    };

    return (
        <TextInput
            label={schema.title}
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            labelId={'custom-input-label'}
            inputId={'custom-text-input'}
            disabled={uiSchema?.['ui:disabled']}
        />
    );
};

export default CustomTextInput;
